import React, { useState } from 'react';
import { Button, Modal, ModalProps } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { createModal } from 'react-modal-promise';
import { CollectionPointFormPage } from 'shared-pages/pages/collection-points/form/collectionpoint-form-page';

type Props = {
  readonly open: boolean;
  readonly close: (result: any) => void;
  readonly title: string;
  readonly initialValues?: any;
  /** body of dialog */
} & ModalProps;

const ModalInput = ({ open, close, initialValues }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal size="xl" show={open} centered backdrop="static">
        <CollectionPointFormPage
          isModal={true}
          paramId={'-1'}
          initialValues={initialValues}
          modalOnClose={(id) => {
            if (id < 0) close(false);
            close(id);
          }}
        />
      </Modal>
    </>
  );
};

export const promiseModalCollectionPointInput = createModal(ModalInput);

